import { combineReducers } from '@reduxjs/toolkit';
import userSlice from './userSlice';
import articleSlice from './articleSlice';
import shopSlice from './shopSlice'
import mouvementTypesSlice from './mouvementTypesSlice';
import salesSlice from './salesSlice'
import quantityReducer from './dynamicQteInmputSlice';
import clientFournisseurSlice from './clientFournisseurSlice'
import snackbarSlice from './snackbarSlice';
import stockSlice from './stockSlice';
import formValidationSlice from './formValidationSlice'
import userPermissionsSlice from './userPermissionsSlice'

const rootReducer = combineReducers({
  snackbar:snackbarSlice,
  user: userSlice,
  article:articleSlice,
  shop:shopSlice,
  mouvementTypes:mouvementTypesSlice,
  sale:salesSlice,
  stock:stockSlice,
  quantity: quantityReducer,
  clientFournisseur:clientFournisseurSlice,
  formValidation:formValidationSlice,
  permission:userPermissionsSlice
});

export default rootReducer;
